import { isPageConfigState, wait } from 'Src/me/pages/guest/proposals/new/utils';

export const scrollToBottomOfChat = async () => {
  const scrollTarget = document.querySelector<HTMLDivElement>('.scroll-target');

  await wait(0.2);

  scrollTarget.scrollIntoView({
    behavior: isPageConfigState('animationDuration') ? 'instant' : 'smooth',
  });
};
